namespace TabAurous.Common {
    export namespace ExcelImportService {
        export const baseUrl = 'Common/ExcelImport';

        export declare function ProductExcelImport(request: ExcelImportRequest, onSuccess?: (response: _ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RateExcelImport(request: ExcelImportRequest, onSuccess?: (response: _ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function LabourExcelImport(request: ExcelImportRequest, onSuccess?: (response: _ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProductLabourExcelImport(request: ExcelImportRequest, onSuccess?: (response: _ExcelImportLabourResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            ProductExcelImport = "Common/ExcelImport/ProductExcelImport",
            RateExcelImport = "Common/ExcelImport/RateExcelImport",
            LabourExcelImport = "Common/ExcelImport/LabourExcelImport",
            ProductLabourExcelImport = "Common/ExcelImport/ProductLabourExcelImport"
        }

        [
            'ProductExcelImport', 
            'RateExcelImport', 
            'LabourExcelImport', 
            'ProductLabourExcelImport'
        ].forEach(x => {
            (<any>ExcelImportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
